'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactLifeCycleController = function () {
  function ContactLifeCycleController(enums, contactService, $ngConfirm, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactLifeCycleController);
    this.enums = enums;
    this.contactService = contactService;
    this.$ngConfirm = $ngConfirm;
    this._$scope = $scope;
  }

  (0, _createClass3.default)(ContactLifeCycleController, [{
    key: 'viewCallDetails',
    value: function viewCallDetails(contactLifeCycleId) {
      var _this = this;

      this.contactService.getCallLog(contactLifeCycleId).then(function (response) {
        _this._$scope.callLog = response.data;

        _this._$scope.exportDialog = _this.$ngConfirm({
          title: 'Call Details',
          contentUrl: 'templates/contact/callLogViewTemplate',
          scope: _this._$scope,
          columnClass: 'm',
          type: 'dark',
          buttons: {
            cancel: {
              text: 'Close',
              btnClass: 'btn-default'
            }
          }
        });
      });
    }
  }, {
    key: 'tempFilterFn',
    value: function tempFilterFn(obj) {
      return obj.contactMethod !== 'InboundCall' && obj.contactMethod !== 'OutboundCall';
    }
  }]);
  return ContactLifeCycleController;
}();

exports.default = ContactLifeCycleController;


// WEBPACK FOOTER //
// ./client/app/components/contact/contactView/contactLifeCycle/contactLifeCycle.controller.js